<div *ngIf="mail$ | async as mail; else empty" @fadeInUp class="mail-view-shell">
  <div class="mail-view-scroll">
    <div class="p-6">
      <div class="mb-6 flex items-start gap-3">
        <p class="text-xl leading-normal flex-1">
          <span>{{ mail.subject }}</span>
        </p>

        <button (click)="printMail()" mat-icon-button type="button" matTooltip="Print">
          <mat-icon svgIcon="mat:print"></mat-icon>
        </button>
        <button [matMenuTriggerFor]="actionsMenu" mat-icon-button type="button">
          <mat-icon svgIcon="mat:more_vert"></mat-icon>
        </button>
      </div>

      <div (click)="toggleDropdown()" class="flex items-center cursor-pointer">
        <div class="flex-1 flex truncate">
          <div class="flex-none w-10 h-10 rounded-full overflow-hidden relative mr-4">
            <img [src]="mail.from.imgUrl" class="h-full w-full object-fit" />
          </div>

          <div class="flex-1 truncate">
            <div class="flex truncate">
              <p class="text-[16px] flex-1 truncate font-medium">
                {{ mail.from.name || mail.from.email }}
              </p>
              <p class="text-[12px] flex-none text-secondary truncate self-end">
                {{ mail.date | vexDateFormatRelative }}
              </p>
            </div>

            <div class="flex items-center cursor-pointer">
              <p class="text-[13px] text-secondary">to {{ mail.to.email || 'me' }}</p>
              <mat-icon class="text-secondary icon-sm" svgIcon="mat:arrow_drop_down"></mat-icon>
            </div>
          </div>
        </div>
      </div>

      <div [@dropdown]="dropdownOpen" class="overflow-hidden">
        <div class="border rounded mt-4 p-3 pr-10 relative text-sm">
          <div *ngFor="let item of mail.addresses" class="flex gap-2 py-1">
            <span class="font-medium w-20">{{ item.type }}:</span>
            <span class="truncate text-secondary">{{ item.name }} {{ item.email }}</span>
          </div>
          <div class="flex gap-2 py-1">
            <span class="font-medium w-20">Date:</span>
            <span class="truncate text-secondary">{{ mail.date | date: "medium" }}</span>
          </div>

          <button (click)="toggleDropdown()" class="absolute top-0 right-0" mat-icon-button type="button">
            <mat-icon class="icon-sm" svgIcon="mat:close"></mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="mail.blockedInfo?.isBlocked" class="mail-view-blocked">
        <div class="mail-view-blocked__title">This is suspicious mail.</div>
        <div class="mail-view-blocked__meta">
          Blocked by {{ mail.blockedInfo?.blockedByUserName || 'user' }}
          <span *ngIf="mail.blockedInfo?.blockedAt">on {{ mail.blockedInfo?.blockedAt | date: "medium" }}</span>
        </div>
        <div class="mail-view-blocked__meta">{{ getBlockedHelpText(mail) }}</div>
        <div class="mail-view-blocked__meta" *ngIf="mail.blockedInfo?.remarks">{{ mail.blockedInfo?.remarks }}</div>
        <div class="mail-view-blocked__actions" *ngIf="canUnblock(mail)">
          <button (click)="unblockSender()" color="primary" mat-stroked-button type="button">
            <mat-icon svgIcon="mat:undo"></mat-icon>
            Unblock Sender
          </button>
        </div>
      </div>

      <div *ngIf="!mail.blockedInfo?.isBlocked" [innerHTML]="mail.body" class="mail-view-body py-6 prose max-w-none"></div>

      <div class="border-b" *ngIf="!mail.blockedInfo?.isBlocked">
        <div *ngIf="mail.attachments.length > 0" class="py-4 flex flex-wrap gap-3">
          <vex-mail-attachment
            *ngFor="let attachment of mail.attachments"
            [attachment]="attachment"
            class="block w-40 h-28 border rounded overflow-hidden"></vex-mail-attachment>
        </div>
      </div>
    </div>
  </div>

  <div class="mail-view-actions flex gap-2">
    <button (click)="reply()" [disabled]="mail.blockedInfo?.isBlocked" mat-stroked-button type="button">
      <mat-icon svgIcon="mat:reply"></mat-icon>
      Reply
    </button>
    <button (click)="replyAll()" [disabled]="mail.blockedInfo?.isBlocked" mat-stroked-button type="button">
      <mat-icon svgIcon="mat:reply_all"></mat-icon>
      Reply all
    </button>
    <button (click)="forward()" [disabled]="mail.blockedInfo?.isBlocked" mat-stroked-button type="button">
      <mat-icon svgIcon="mat:forward"></mat-icon>
      Forward
    </button>
    <button (click)="printMail()" [disabled]="mail.blockedInfo?.isBlocked" mat-stroked-button type="button">
      <mat-icon svgIcon="mat:print"></mat-icon>
      Print
    </button>
  </div>
</div>

<ng-template #empty>
  <div class="flex-auto flex flex-col justify-center items-center p-6 text-secondary">
    <mat-icon class="icon-3xl mb-3" svgIcon="mat:mark_email_unread"></mat-icon>
    <p class="text-xl font-semibold">Select a mail to read</p>
  </div>
</ng-template>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
  <button (click)="reply()" [disabled]="(mail$ | async)?.blockedInfo?.isBlocked" mat-menu-item>
    <mat-icon svgIcon="mat:reply"></mat-icon>
    <span>Reply</span>
  </button>
  <button (click)="forward()" [disabled]="(mail$ | async)?.blockedInfo?.isBlocked" mat-menu-item>
    <mat-icon svgIcon="mat:forward"></mat-icon>
    <span>Forward</span>
  </button>
  <button (click)="printMail()" [disabled]="(mail$ | async)?.blockedInfo?.isBlocked" mat-menu-item>
    <mat-icon svgIcon="mat:print"></mat-icon>
    <span>Print</span>
  </button>
  <button (click)="blockForMe()" [disabled]="(mail$ | async)?.blockedInfo?.isBlocked" mat-menu-item>
    <mat-icon svgIcon="mat:block"></mat-icon>
    <span>Block For Me</span>
  </button>
  <button (click)="blockAsSuspicious()" [disabled]="(mail$ | async)?.blockedInfo?.isBlocked" mat-menu-item>
    <mat-icon svgIcon="mat:gpp_bad"></mat-icon>
    <span>Block As Suspicious</span>
  </button>
  <button *ngIf="canUnblock(mail$ | async)" (click)="unblockSender()" mat-menu-item>
    <mat-icon svgIcon="mat:undo"></mat-icon>
    <span>Unblock Sender</span>
  </button>
  <button (click)="deleteMail()" mat-menu-item>
    <mat-icon svgIcon="mat:delete"></mat-icon>
    <span>Move to Trash</span>
  </button>
</mat-menu>
